export const jaX = {
  footer: { privacy: "プライバシーポリシー" },
  join: {
    ph: { region: "地域 / 都道府県" },
    privacy: "",
    privacyLink: "プライバシーポリシー",
    privacySuffix: "を読み、同意します(私の情報が国外で処理される可能性を含みます)。",
  },
  database: {
    dirKicker: "公開ディレクトリ",
    dirTitle: "同意の上で公開",
    dirEmpty: "公開エントリーはまだありません。登録した生産者・組織が掲載に同意するたびに、このディレクトリは成長します。",
  },
  verify: {
    checking: "登録を確認しています…",
    okTitle: "登録が完了しました",
    okText: "ありがとうございます。World Rhubarb Associationへの登録が完了しました。Databaseアンケートへのリンクを含むウェルカムメールをお送りしています。",
    errTitle: "リンクが無効か、使用済みです",
    errText: "この確認リンクは無効か、すでに使用されています。確認メールが届いていない場合は、フォームから再度ご登録ください。",
    home: "サイトに戻る",
  },
  survey: {
    kicker: "グローバル・ルバーブ・データベース",
    title: "データベースアンケート",
    intro: "World Rhubarb Associationへのご登録ありがとうございます。このアンケートは、同意に基づく検証済みの世界ルバーブ産業記録——Global Rhubarb Database——を構築するためのものです。回答は任意であり、ご登録には影響しません。",
    verifyTitle: "ご登録情報",
    refPh: "登録参照番号(例: WRA-AB12CD34) *",
    emailPh: "登録メールアドレス *",
    aboutTitle: "農園・組織について",
    farmPh: "農園 / 組織名 *",
    countryPh: "国 *",
    regionPh: "地域 / 州 / 都道府県",
    websitePh: "ウェブサイト / SNS(任意)",
    orgTypePh: "組織の種別 *",
    orgTypes: ["農園 / 生産者", "協同組合", "食品企業", "レストラン", "小売", "研究機関", "団体", "個人 / 愛好家", "その他"],
    rhubarbTitle: "ルバーブについて",
    varietiesPh: "栽培・取扱しているルバーブ品種",
    areaPh: "おおよその栽培面積(例: 2 ha)",
    productionPh: "おおよその年間生産量(例: 5 t)",
    consentTitle: "公開への同意",
    consentAgree: "選択した情報がGlobal Rhubarb Databaseに公開掲載されることに同意します。",
    consentDecline: "自分の情報を公開掲載することを希望しません。",
    fieldsLabel: "公開を許可する項目を選択:",
    fieldLabels: {
      farm_name: "農園 / 組織名", country: "国", region: "地域",
      website: "ウェブサイト / SNS", org_type: "組織の種別", varieties: "ルバーブ品種",
      cultivation_area: "栽培面積", annual_production: "年間生産量",
    },
    noteNoConsent: "公開に同意しなくても、登録とアンケート回答は可能です。回答はWRAの研究にのみ利用され、公開されることはありません。",
    crossBorder: "私の情報が、プライバシーポリシーに記載のとおり、国外のサービス提供者やサーバー(国外ホスティング・メール配信サービスを含む)によって処理される可能性があることを理解しました。",
    privateNote: "メールアドレスおよび選択しなかった項目は公開されません。情報の訂正・更新・公開掲載の削除・データ削除は、コンタクトフォームからいつでも依頼できます。",
    submit: "アンケートを送信",
    submitting: "送信中…",
    thanks: "アンケートを受け付けました",
    successConsent: "ありがとうございます。選択された情報は確認の上、Global Rhubarb Databaseに掲載されます。",
    successNoConsent: "ありがとうございます。回答は記録され、非公開のまま保管されます。",
    errNotFound: "その参照番号とメールアドレスの組み合わせの登録が見つかりませんでした。両方をご確認の上、もう一度お試しください。",
    toastOk: "アンケートを送信しました。",
    toastErr: "送信に失敗しました。もう一度お試しください。",
    editNote: "すでに回答済みですか? 再送信すると以前の回答が更新されます。",
  },
  privacy: {
    kicker: "プライバシーポリシー",
    titleA: "個人情報の", titleAccent: "取り扱いについて。",
    updated: "最終更新: 2026年8月",
    intro: "World Rhubarb Association(WRA)は2026年に創設された任意の国際イニシアチブです。このポリシーでは、収集する個人情報、その目的、保護の方法を説明します。",
    sections: [
      { h: "収集する情報", body: [
        "登録フォーム: お名前、農園・組織名、国、地域、メールアドレス、メンバー種別。",
        "Databaseアンケート(任意): ウェブサイト・SNS、組織の種別、ルバーブ品種、おおよその栽培面積、おおよその年間生産量。",
        "登録・Database構築に必要のない個人情報は収集しません(最小限の収集)。",
      ]},
      { h: "利用目的", body: [
        "Global Rhubarb Databaseの構築・運営のため。",
        "World Rhubarb Associationからの連絡のため(ウェルカムメール、アンケートのご案内、ネットワークのお知らせ等)。",
        "メンバーシップの管理およびお問い合わせへの対応のため。",
      ]},
      { h: "公開情報と非公開情報", body: [
        "公開しません: メールアドレス、電話番号、個人の住所、その他の個人的な連絡先。",
        "明示的な同意があり、かつご本人が選択した項目のみ公開します: 農園・組織名、国、地域、ウェブサイト・SNS、組織の種別、ルバーブ品種、おおよその栽培面積、おおよその年間生産量。",
        "公開に同意しなくても、登録とアンケート回答は可能です。",
      ]},
      { h: "サービス提供者の利用", body: [
        "データベースの管理・運営やメール配信のため、必要な範囲でサービス提供者(ホスティング・メール配信サービス等)を利用する場合があります。提供者とは適切なデータ取り扱い条件のもとで契約します。",
      ]},
      { h: "国外での処理", body: [
        "WRAは世界中の生産者・関係者を対象としています。お預かりした情報は、国外のサービス・サーバーによって処理される場合があり、日本の個人情報保護法(APPI)上の越境移転に該当する可能性があります。",
        "フォームの送信をもって、この国外的な処理をご了承いただいたものとみなします。法令上必要な場合、国外の第三者への個人データ提供前に別途同意を取得します。",
      ]},
      { h: "データの管理", body: [
        "個人情報は安全に保管します。アクセスはWRA創設チームに限定し、管理画面はパスワードで保護されています。",
      ]},
      { h: "訂正・更新・削除", body: [
        "情報の訂正、更新、公開掲載の削除、データの削除は、メインページのコンタクトフォームからいつでも依頼できます。本人確認の上、速やかに対応します。",
      ]},
      { h: "お問い合わせ", body: [
        "プライバシーに関するご質問・ご依頼は、メインページのコンタクトフォームからお願いします。",
      ]},
    ],
  },
};
